/* D18 · Lucidia page interaction (Q3, Oct 2026). Loaded with dz-pdp-q3.css on the Lucidia template only.
   Runs after the theme's deferred scripts (DOMContentLoaded), so the tab bar and the phone bar already exist.
   No new words; every change here is behaviour. Evidence: strategy/lucidia-2026-10/. */
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('dz-pdp-q3')) return;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var main = document.querySelector('#MainContent > [id$="__main"]');
    if (!main) return;

    /* ---------- Tab bar ---------- */
    var nav = document.getElementById('product-section-nav');
    if (nav) {
      /* It was moved to the end of <body>, so keyboard users reached it after the footer. Right before <main> it
         is still outside any transformed parent (fixed position keeps working) and comes after the header. */
      var mainContent = document.getElementById('MainContent');
      if (mainContent && mainContent.parentNode === document.body) document.body.insertBefore(nav, mainContent);

      var tabs = nav.querySelectorAll('.product-section-nav__tab');
      function syncCurrent() {
        tabs.forEach(function (t) {
          if (t.classList.contains('product-section-nav__tab--active')) t.setAttribute('aria-current', 'true');
          else t.removeAttribute('aria-current');
        });
      }
      syncCurrent();
      var tabObserver = new MutationObserver(syncCurrent);
      tabs.forEach(function (t) { tabObserver.observe(t, { attributes: true, attributeFilter: ['class'] }); });

      /* Keyboard: after Enter the page scrolled but focus stayed in the bar; move it to the section (no ring on
         mouse clicks, because a click carries a detail count). */
      tabs.forEach(function (t) {
        t.addEventListener('click', function (e) {
          if (e.detail !== 0) return;
          var target = document.getElementById(t.getAttribute('href').slice(1)) ||
            document.querySelector('[id$="__' + t.getAttribute('data-target') + '"]');
          if (!target) return;
          if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
          setTimeout(function () { target.focus({ preventScroll: true }); }, 850);
        });
      });

    }

    /* ---------- Phone bar: its own loading look ---------- */
    var atc = main.querySelector('.product-form__submit');
    var sticky = document.querySelector('#product-sticky-atc .product-sticky-atc__button');
    if (atc && sticky) {
      new MutationObserver(function () {
        var busy = atc.classList.contains('loading') || atc.getAttribute('aria-disabled') === 'true';
        sticky.classList.toggle('is-busy', busy);
        if (busy) sticky.setAttribute('aria-busy', 'true');
        else sticky.removeAttribute('aria-busy');
      }).observe(atc, { attributes: true, attributeFilter: ['class', 'aria-disabled'] });
    }
    if (atc) {
      new MutationObserver(function () {
        if (atc.classList.contains('loading')) atc.setAttribute('aria-busy', 'true');
        else atc.removeAttribute('aria-busy');
      }).observe(atc, { attributes: true, attributeFilter: ['class'] });
    }

    /* ---------- Cart drawer after Add to cart ----------
       Shopify's wallet scripts behind the express buttons (D17c) evaluated while the drawer slid in and froze it
       for 100-130 ms on a slow phone. From this page the express row is held back until the drawer stands still;
       its 44 px stay reserved, so nothing moves when the buttons arrive. */
    customElements.whenDefined('cart-drawer').then(function () {
      var C = customElements.get('cart-drawer');
      if (!C || C.prototype.__dzqHold) return;
      var render = C.prototype.renderContents;
      C.prototype.renderContents = function (state) {
        var held = null;
        try {
          var html = state && state.sections && state.sections['cart-drawer'];
          if (html && html.indexOf('dz-cart-express') !== -1) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var row = doc.querySelector('.dz-cart-express');
            if (row && row.innerHTML.trim()) {
              held = row.innerHTML;
              row.innerHTML = '';
              row.setAttribute('data-dzq-held', '');
              state.sections['cart-drawer'] = doc.body.innerHTML;
            }
          }
        } catch (e) { held = null; }
        render.call(this, state);
        if (held === null) return;
        var drawer = this;
        setTimeout(function () {
          var row = drawer.querySelector('.dz-cart-express[data-dzq-held]');
          if (!row) return;
          row.innerHTML = held;
          row.removeAttribute('data-dzq-held');
        }, 320);
      };
      C.prototype.__dzqHold = true;
    });

    /* ---------- Gallery: photos load before they are shown ---------- */
    var list = main.querySelector('.product__media-list');
    function eager(img) { if (img && img.loading === 'lazy') img.loading = 'eager'; }
    main.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
      function warm() {
        var slide = document.getElementById('Slide-' + li.getAttribute('data-target'));
        if (slide) eager(slide.querySelector('img'));
      }
      li.addEventListener('pointerenter', warm, { passive: true });
      li.addEventListener('focusin', warm);
      li.addEventListener('touchstart', warm, { passive: true });
    });
    if (list) {
      /* phone: the first swipe loads the rest of the strip */
      list.addEventListener('scroll', function once() {
        list.removeEventListener('scroll', once);
        list.querySelectorAll('img[loading="lazy"]').forEach(eager);
      }, { passive: true });
    }

    /* ---------- Phone bar price follows the chosen plan ----------
       With Subscribe and save chosen, the main price and the 1-bottle card show $26.99 but the phone bar kept the
       one-time $29.99. It now shows the same price as the card (no new words, the card's own labels). */
    var card = document.getElementById('pt-single');
    var stickyPrice = document.querySelector('#product-sticky-atc .product-sticky-atc__price');
    if (card && stickyPrice && card.dataset.sub && card.dataset.onetime) {
      var bound = false;
      function bindPlan() {
        if (bound) return true;
        var box = document.querySelector('.shopify_subscriptions_app_container');
        if (!box || !box.querySelector('input[type="radio"]')) return false;
        bound = true;
        function show() {
          var c = box.querySelector('input[type="radio"]:checked');
          stickyPrice.textContent = c && c.dataset.radioType === 'selling_plan' ? card.dataset.sub : card.dataset.onetime;
        }
        box.addEventListener('change', show);
        show();
        return true;
      }
      if (!bindPlan()) { setTimeout(bindPlan, 500); setTimeout(bindPlan, 1500); setTimeout(bindPlan, 3000); }
    }
  });
})();
